module.exports = __webpack_public_path__ + "img/sidebar_selected_motion_sensor.83c7151c.svg";